import { type InputHTMLAttributes, forwardRef } from 'react'
import { cn } from '@/lib/utils'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    variant?: 'default' | 'search'
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ className, variant = 'default', type = 'text', ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'flex w-full rounded-md border bg-white dark:bg-gray-950 px-3 py-2 text-sm',
                    'text-gray-900 dark:text-white',
                    'placeholder:text-gray-400 dark:placeholder:text-gray-500',
                    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:focus-visible:ring-blue-600',
                    'disabled:cursor-not-allowed disabled:opacity-50',
                    {
                        'border-gray-200 dark:border-gray-700': variant === 'default',
                        'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800': variant === 'search',
                    },
                    className
                )}
                ref={ref}
                {...props}
            />
        )
    }
)

Input.displayName = 'Input'

export { Input }
